import { ArrowDownRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { changeLabel, fmt, type ValueKind } from './insightFormat';
import type { Comparable } from '../../core/types/insights';
type Props = {
  label: string;
  value: Comparable;
  kind?: ValueKind;
  hint?: string;
  /** Meer is slechter (no-shows): de kleur draait om, de pijl niet. */
  lowerIsBetter?: boolean;
  size?: 'lg' | 'md';
};

/**
 * Eén kerncijfer met het verschil t.o.v. de vorige periode. Hoort in een <dl>. Het verschil
 * staat altijd in tekst ("+12%"), de kleur is alleen een extra.
 */
export function Kpi({
  label,
  value,
  kind = 'number',
  hint,
  lowerIsBetter = false,
  size = 'md'
}: Props) {
  const change = changeLabel(value, kind);
  const good = change && !change.flat && change.up !== lowerIsBetter;
  const Icon = change?.up ? ArrowUpRightIcon : ArrowDownRightIcon;
  return <div className="flex min-w-0 flex-col" data-id="element-1891" data-mp="2fgm1jlzv7e18">
      <dt className="text-[12px] leading-snug text-muted" data-id="element-1892" data-mp="2kexcy15t5wlk">{label}</dt>
      <dd className={`mt-1 tabular-nums text-ink ${size === 'lg' ? 'font-display text-[1.9rem] font-light leading-none' : 'text-[18px] leading-tight'}`} data-id="element-1893" data-mp="2kh9rs5g9rque">{fmt(value.current, kind)}</dd>
      <dd className="mt-1 text-[12px] text-muted" data-id="element-1894" data-mp="21dkh7chjs32j">
        {change ? <span className="inline-flex flex-wrap items-center gap-x-1" data-id="element-1895" data-mp="2fck70ngsqo0a">
            <span className={`inline-flex items-center gap-0.5 ${change.flat ? '' : good ? 'text-sage' : 'text-clay'}`} data-id="element-1896" data-mp="2aes5d1qcnniw">
              {!change.flat && <Icon className="h-3 w-3" strokeWidth={2} aria-hidden="true" data-id="element-1897" data-mp="1mpqyvk12umg9" />}
              {change.text}
            </span>
            <span data-id="element-1898" data-mp="1il9k5z9kqzcc">t.o.v. {fmt(value.previous, kind)}</span>
          </span> : <span data-id="element-1899" data-mp="1wg273irsnhsy">Geen vergelijking</span>}
        {hint && <span className="block text-[11px]" data-id="element-1900" data-mp="1rnsiq76bupss">{hint}</span>}
      </dd>
    </div>;
}